var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceIssuedBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M60.6 36.1h34.5M77.8 104.7v-49M60.6 64.3h34.5M60.6 72.7h34.5M60.6 81.2h33.7M95.1 89.2H62.2M95.1 96.6H60.6M60.6 45.1h34.5M60.6 84.8V55.7h34.5v49H60.6V91.3M45.5 44.7H31.2V31.2c0-3.8 3.2-6.9 7.2-6.9 3.9 0 7.2 3.1 7.2 6.9v13.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M38.4 24.2h64.5c3.9 0 7.2 3.1 7.2 6.9v87.5H52.4M45.5 44.6v14.5M36.3 71l-1.6 12.2v15.2l1.6 14.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M36.3 70.7v.3l9.2-11.8 2.2-2.9c1.3-1.6 3.6-1.9 5.2-.6.9.7 1.4 1.8 1.4 2.9 0 .8-.3 1.6-.8 2.3l-7.8 9.9-1.2 13.5 3.8 8.5 7.7-7.5c1.2-1.2 3.1-1.4 4.5-.5.3.2.5.4.8.6.8.8 1.2 2 1 3.1 0 .2-.1.5-.2.7-.2.5-.5 1-.9 1.4l-.7.7-12.4 12.1v9.2M31.2 112.6h21.2v14H31.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIssuedBig);
export default __webpack_public_path__ + "static/media/invoiceIssuedBig.bdfb81759e6f421d34e79923275d61c9.svg";
export { ForwardRef as ReactComponent };